import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { groupItem, premiumGroup, ReservationsAttribute } from "types/types";
import { ReservationService } from "app/_services/reservation/reservation.service";
import * as _ from "lodash";
import * as moment from "moment";

declare let $: any;
declare let toastr: any;

@Component({
    selector: "app-reservation-group",
    templateUrl: "reservation.group.component.html",
    styleUrls: ["reservation.group.component.scss"]
})
export class ReservationGroupComponent implements OnInit {

    @Input()
    public reservationItems: groupItem[] = [];

    @Input()
    public searchItems: groupItem[] = [];

    @Input()
    public type: string;

    public reservationLogs: ReservationsAttribute[] = [];
    public reservationLogItems = [];
    public logMap: any;
    public status: boolean = false;

    public reservationTime;

    public sortOrder = [
        'booked',
        'fulfill',
        'cancel',
        'error'
    ];
    constructor(private activeModal: NgbActiveModal,
        private reservationService: ReservationService) {
    }

    ngOnInit() {
        this.logMap = _.keyBy(this.reservationItems.concat(this.searchItems), "id");
        this.getData();
    }

    getData() {
        this.reservationService.get(this.type, 0)
            .then(r => {
                this.reservationLogs = r.sort((a, b) => b.reservation_time - a.reservation_time)
                    .sort((a, b) => this.sortOrder.indexOf(a.status) - this.sortOrder.indexOf(b.status));
            })
            .catch(e => {
                console.log(e);
            })
    }

    ngAfterViewInit() {
        $('#reservation_datetimepicker').datetimepicker({
            todayHighlight: true,
            autoclose: true,
            pickerPosition: 'bottom-left',
            todayBtn: true,
            stepping: 1,
            format: 'yyyy-mm-dd hh:ii'
        });

        $(document).on('change', '#reservation_datetimepicker', (e) => {
            this.reservationTime = moment(e.target.value).format('YYYY-MM-DD HH:mm');
        });
    }

    close() {
        this.activeModal.close();
    }

    reservation() {
        if (new Date(this.reservationTime).getTime() < new Date().getTime()) {
            toastr.warning('예약날짜가 과거입니다. 수정해주세요.');
            return;
        }
        let rItems = this.reservationItems;
        const info = {
            type: 'p_group_tab',
            task: 'update',
            ref_id: 0,
            reservation_time: new Date(this.reservationTime).getTime(),
            param: rItems.map((r, i) => ({ id: r.id, priority: i, status: r.status }))
        }
        this.reservationService.group({ info })
            .then(() => this.getData())
            .catch(e => console.log(e));
    }

    showDetail(log) {
        this.reservationLogItems = JSON.parse(log.param) || [];
        this.reservationLogItems.forEach(l => {
            if (this.logMap[l.id]) {
                l.title = this.logMap[l.id].title;
            }
        });
    }

    selectChange(event) {
        if (event) {
            this.reservationItems.unshift(event);
            _.remove(this.searchItems, i => i.id == event.id);
            this.searchItems = [...this.searchItems];
        }
    }

    drop(event: CdkDragDrop<premiumGroup[]>) {
        moveItemInArray(this.reservationItems, event.previousIndex, event.currentIndex);
    }

    deleteItem(i) {
        let reservationItem = this.reservationItems.splice(i, 1)[0];
        reservationItem.bindLabel = reservationItem.status === 'S3' || reservationItem.status === 'D2'
            ? `[${reservationItem.id}] - ${reservationItem.title}`
            : `[${reservationItem.id}] - [비활성] ${reservationItem.title}`;
        this.searchItems = [...this.searchItems, reservationItem];
    }

    cancelReservation(event, id) {
        event.stopImmediatePropagation();
        this.reservationService.cancel({ id: id, type: this.type }, {})
            .then(() => {
                this.getData();
            })
            .catch(e => {
                console.log(e);
            })
    }

    ngOnDestroy() {
        $('#reservation_datetimepicker').datetimepicker('remove');
    }

}
